import { streamingRestApi } from '@/service/streamingApi'
import { PipelineFailedProvision } from '@/types/streams/pipeline'

import { createBaseTableStore } from '../table'
import { FetchApiArgs, FetchApiResponse } from '../table/table.types'

const fetchApi = async (args: FetchApiArgs): Promise<FetchApiResponse<PipelineFailedProvision>> => {
  const { signal } = args

  const { data } = await streamingRestApi.endpoints.pipeline.getFailedToProvision(signal)

  return {
    content: data,
    totalElements: data.length
  }
}

export const useFailedProvisionStore = createBaseTableStore<PipelineFailedProvision>({
  storeName: 'DGE Failed to provision',
  fetchApi
})
